import React from 'react';

import { Title, forResource, withStripeTokenRequest } from '../common/container/Container.jsx';
import { Label as FormLabel, withSubmission } from '../common/container/Form.jsx';
import { Fullscreen as LoadingFull } from '../common/container/Loading.jsx';
import { ListArtworkAdd, Popup } from '../common/container/Popup.jsx';
import { Artwork as ArtworkSlider } from '../common/container/Slider.jsx';
import Carousel, { ThumbDot } from '../common/container/Carousel.jsx';
import { Follow as FollowButton, LinkButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { Input } from '../common/input/Text.jsx';

let _ArtInst;
class _Art extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentImageSlide: 0,
            artistBioExpanded: false,
            Email: '',
            Message: "Hi, I'm interested in purchasing this work. Could you please provide more information about the piece?",
            Name: '',
            buttonArrowShow: false,
        };

        this.handleArtistBioToggle = this.handleArtistBioToggle.bind(this);
        this.handleArtistFollowChange = this.handleArtistFollowChange.bind(this);
        this.handleArtworkImageClick = this.handleArtworkImageClick.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleArtworkZoomClose = this.handleArtworkZoomClose.bind(this);
        this.handleBuyNowModalClose = this.handleBuyNowModalClose.bind(this);
        this.handleBuyNowModalOpen = this.handleBuyNowModalOpen.bind(this);
        this.handleGalleryFollowChange = this.handleGalleryFollowChange.bind(this);
        this.handleInquire = this.handleInquire.bind(this);
        this.handleInquireModalClose = this.handleInquireModalClose.bind(this);
        this.handleInquireModalOpen = this.handleInquireModalOpen.bind(this);
        this.handleLikeArtwork = this.handleLikeArtwork.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
        this.handleListArtworkAddModalOpen = this.handleListArtworkAddModalOpen.bind(this);
        this.handleMakeOfferModalClose = this.handleMakeOfferModalClose.bind(this);
        this.handleMakeOfferModalOpen = this.handleMakeOfferModalOpen.bind(this);
        this.handleParseArtistArtworkResults = this.handleParseArtistArtworkResults.bind(this);
        this.handleParseGalleryArtworkResults = this.handleParseGalleryArtworkResults.bind(this);
        this.handleParseRecentArtworkResults = this.handleParseRecentArtworkResults.bind(this);
        this.handleParseRelatedArtworkResults = this.handleParseRelatedArtworkResults.bind(this);
        this.handleMoreImagesModalClose = this.handleMoreImagesModalClose.bind(this);
        this.handleMoreImagesModalOpen = this.handleMoreImagesModalOpen.bind(this);
        this.handleShareModalClose = this.handleShareModalClose.bind(this);
        this.handleShareModalOpen = this.handleShareModalOpen.bind(this);
        this.handleVirtualInstallModalClose = this.handleVirtualInstallModalClose.bind(this);
        this.handleVirtualInstallModalOpen = this.handleVirtualInstallModalOpen.bind(this);
    }

    componentDidMount() {
        _ArtInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            if (window.Stripe && responseData.Gallery) {
                Stripe.setPublishableKey(responseData.Gallery.StripePublishableKey);
            }

            Artcloud.mkt.art._isfavorite(responseData);
            Artcloud.mkt.artists._isfollowing(responseData.Artist);
            Artcloud.mkt.galleries._isfollowing(responseData.Gallery);

            if (responseData.Images) {
                responseData.Images.forEach(function (d) {
                    if (d.Height / d.Width < 1.2) {
                        d.orientation = 'horizontal';
                    } else {
                        d.orientation = 'vertical';
                    }
                });
            }
            const user = Artcloud.auth.user;
            if (user) {
                let name;
                if (user.Name) {
                    name = user.Name.Full;
                }
                component.setState({
                    Email: user.Email,
                    Name: name
                });
            }

            var recents = Artcloud.storage.get(Artcloud.storage.keys.recent) || {};
            if (!recents.Data) {
                recents.Data = [];
            }
            const ids = recents.Data.map(x => x.ArtId);
            const idx = ids.indexOf(responseData.ArtId);
            //??? add to get by id?
            const inv = {
                Artist: {
                    ArtistId: responseData.Artist.ArtistId,
                    Name: responseData.Artist.Name,
                    Slug: responseData.Artist.Slug
                },
                ArtId: responseData.ArtId,
                Debug: null, //???
                Dimensions: responseData.Dimensions.Display.Formatted,
                DisplayPrice: '--', //fetch
                Gallery: {
                    Company: responseData.Gallery.Company,
                    GalleryId: responseData.Gallery.GalleryId,
                    Slug: responseData.Gallery.Slug
                },
                Genre: null, //???
                Image: responseData.Images[0],
                IsOpted: true, //???
                PriceBucket: null, //???
                Slug: responseData.Slug,
                Subtitle: null, //???
                Title: responseData.Title
            };
            if (idx > -1) {
                recents.Data.splice(idx, 1);
            }
            recents.Data = [inv, ...recents.Data];

            component.setState({
                Recents: recents
            });
            Artcloud.storage.put(Artcloud.storage.keys.recent, recents);

            // time arrow animation
            setTimeout(() => component.setState({ buttonArrowShow: true }), 1500);
        });
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = 'true';
        script.defer = 'true';
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    componentWillUnmount() {
        _ArtInst = undefined;
    }

    handleArtistBioToggle(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.artistBioExpanded && !this.state.artistBioHeightCollapsed) {
            const element = document.getElementById('artistBio');
            if (element) {
                this.setState({
                    artistBioHeightCollapsed: element.offsetHeight,
                    artistBioHeightExpanded: element.scrollHeight,
                });
            }
        }
        const artistBioExpanded = !this.state.artistBioExpanded;
        this.setState({
            artistBioExpanded: artistBioExpanded
        });
    }

    handleArtistFollowChange() {
        const data = this.props.data;
        if (!data.Artist) {
            return;
        }

        const component = this;
        Artcloud.mkt.artists.updateFollowing(data.Artist.ArtistId, !data.Artist.IsFollowing, data.Artist.Name, function (success) {
            if (success != true || !_ArtInst) {
                return;
            }
            data.Artist.IsFollowing = !data.Artist.IsFollowing;
            component.props.onUpdateData(data);
        });
    }

    handleArtworkImageClick(event) {
        if (event) {
            event.preventDefault();
        }
        if (!event.currentTarget.attributes.value) {
            return;
        }
        const index = parseInt(event.currentTarget.attributes.value.value, 10);
        if (isNaN(index)) {
            return;
        }
        this.setState({
            artworkZoomModal: {
                imageIndex: index,
                visible: true
            }
        });
    }

    handleArtworkLikeChange(d) {
        if (!_ArtInst) {
            return;
        }
        this.setState({
            listArtworkAddModal: {
                data: d,
                visible: true
            }
        });
    }

    handleArtworkZoomClose() {
        this.setState({
            artworkZoomModal: undefined
        });
    }

    handleBuyNowModalClose() {
        this.setState({
            buyNowModal: undefined
        });
    }

    handleBuyNowModalOpen() {
        this.setState({
            buyNowModal: true
        });
    }

    handleGalleryFollowChange() {
        const data = this.props.data;
        if (!data.Gallery) {
            return;
        }
        const component = this;
        Artcloud.mkt.galleries.updateFollowing(data.Gallery.GalleryId, !data.Gallery.IsFollowing, data.Gallery.Company, function (success) {
            if (success != true || !_ArtInst) {
                return;
            }
            data.Gallery.IsFollowing = !data.Gallery.IsFollowing;
            component.props.onUpdateData(data);
        });
    }

    handleInquire(data, callback) {
        const component = this;
        const recap = document.getElementsByName('g-recaptcha-response');
        if (!recap || !recap.length || !recap[0].value) {
            if (callback) {
                callback(false, 'Please verify your humanity.');
            }
            return;
        }
        const validation = recap[0].value;
        if (component.state.inquiring) {
            return;
        }
        component.setState({
            inquiring: true
        });
        const postData = {
            GalleryId: component.props.data.Gallery && component.props.data.Gallery.GalleryId,
            ArtId: component.props.data.ArtId,
            Name: data.Name,
            Email: data.Email,
            Message: data.Message,
            Phone: data.Phone,
            Validation: validation
        };
        if (window && Cookies) {
            postData.Referrer = Cookies.get(Artcloud.auth.keys.cookies.referrer)
            postData.Utm = Cookies.get(Artcloud.auth.keys.cookies.utm)
        }
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.inquiries.art.post(),
            postData,
            function () {
                if (!_ArtInst) {
                    return;
                }
                component.setState({
                    inquiring: false
                });
                if (callback) {
                    callback(true, 'Your message has been sent. Thank you!');
                }
            }, function () {
                if (!_ArtInst) {
                    return;
                }
                component.setState({
                    inquiring: false
                });
                if (callback) {
                    callback(false, 'There was a problem sending your message. Please wait a moment and try again.');
                }
            }
        );
    }

    handleInquireModalClose() {
        this.setState({
            inquireModal: undefined
        });
    }

    handleInquireModalOpen() {
        this.setState({
            inquireModal: true
        });
    }

    handleLikeArtwork() {
        if (!this.props.data) {
            return;
        }
        const component = this;
        const artwork = { ...this.props.data };
        if (artwork.Images && artwork.Images.length) {
            artwork.Image = artwork.Images[0];
        }
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_ArtInst) {
                return;
            }
            const data = component.props.data;
            data.IsFavorite = !data.IsFavorite;
            component.props.onUpdateData(data);
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    handleListArtworkAddModalOpen(nested) {
        if (!this.props.data) {
            return;
        }
        const artwork = { ...this.props.data };
        if (artwork.Images && artwork.Images.length) {
            artwork.Image = artwork.Images[0];
        }
        this.setState({
            listArtworkAddModal: {
                data: artwork,
                nested: nested,
                visible: true
            }
        });
    }

    handleMakeOfferModalClose() {
        this.setState({
            offerModal: undefined
        });
    }

    handleMakeOfferModalOpen() {
        this.setState({
            offerModal: true
        });
    }

    handleMoreImagesModalClose() {
        this.setState({
            moreImagesModal: undefined,
            Message: "Hi, I'm interested in purchasing this work. Could you please provide more information about the piece?",
        });
    }

    handleMoreImagesModalOpen() {
        this.setState({
            moreImagesModal: true,
            Message: "Hi, I would like to see more images of this artwork.",
        });
    }

    handleParseArtistArtworkResults(responseData) {
        if (!responseData.Art || !responseData.Art.length || (responseData.Art.length == 1 && responseData.Art[0].ArtId == this.props.data.ArtId)) {
            return [];
        }
        return responseData.Art;
    }

    handleParseGalleryArtworkResults(responseData) {
        const results = [];
        if (responseData.Data) {
            const artId = this.props.data.ArtId;
            let artistId;
            if (this.props.data.Artist) {
                artistId = this.props.data.Artist.ArtistId;
            }
            responseData.Data.forEach(function (d) {
                if (d.ArtId == artId || !d.Artist || d.Artist.ArtistId == artistId) {
                    return;
                }
                results.push(d);
            });
        }
        return results;
    }

    handleParseRecentArtworkResults(responseData) {
        const results = [];
        const recents = Artcloud.storage.get(Artcloud.storage.keys.recent);
        recents.Data.forEach(x => {
            var r = responseData.data.filter(y => y.id === x.ArtId);
            if (r.length > 0) {
                if (r[0].o) {
                    x.DisplayPrice = r[0].p;
                    results.push(x);
                }
            }
        })
        return results;
    }

    handleParseRelatedArtworkResults(responseData) {
        const results = [];
        if (responseData.Art) {
            const artId = this.props.data.ArtId;
            responseData.Art.forEach(function (d) {
                if (d.ArtId == artId) {
                    return;
                }
                results.push(d);
            });
        }
        return results;
    }

    handleShareModalClose() {
        this.setState({
            shareModal: undefined
        });
    }

    handleShareModalOpen(event, nested) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            shareModal: {
                nested: nested,
                visible: true
            }
        });
    }

    handleVirtualInstallModalOpen(event) {
        if (event) {
            event.preventDefault();
        }

        this.setState({
            roomViewModal: {
                imageIndex: 0,
                visible: true
            }
        });
    }

    handleVirtualInstallModalClose() {
        this.setState({
            roomViewModal: undefined
        });
    }

    render() {
        let artistArtworkSliderTitleContent, artistLink, galleryArtworkSliderTitleContent;
        if (this.props.data) {
            if (this.props.data.Artist) {
                artistArtworkSliderTitleContent = (
                    <Title small={true}>
                        <h2>Other works by {this.props.data.Artist.Name}</h2>
                        <Arrows config={{ size: 'small' }} display="View All" link={`/artist/${this.props.data.Artist.Slug}`} />
                    </Title>
                );
                artistLink = `/artist/${this.props.data.Artist.Slug}`;
            }
            if (this.props.data.Gallery && this.props.data.Gallery.Type != 2) {
                galleryArtworkSliderTitleContent = (
                    <Title small={true}>
                        <h2>Other works from {this.props.data.Gallery.Company}</h2>
                        <Arrows config={{ size: 'small' }} display="View All" link={`/gallery/${this.props.data.Gallery.Slug}`} />
                    </Title>
                );
            }
        }
        const component = this;
        const data = component.props.data || {};
        const slides = [];
        const thumbs = [];

        if (data.Images && data.Images.length >= 1) {
            data.Images.forEach((d, i) => {
                slides.push((
                    <div key={d.ImageId} className="slider--artwork__item" data-orientation={d.orientation}>
                        <a href="#" value={i} onClick={component.handleArtworkImageClick}>
                            <img alt={d.Title} src={`${d.GiantUrl}`} style={{ cursor: 'zoom-in' }} />
                        </a>
                    </div>
                ));
                thumbs.push((
                    <ThumbDot key={`${i}`} d={d} />
                ))
            });
            // Add CTA Slide
            slides.push((
                <div key={`cta-slide`} className="slider--artwork__item slider--artwork__item--cta">
                    <h3 className="slider--artwork__item--cta__title" >Want to see additional images of this piece?</h3>
                    <button className="btn btn--dark btn--medium btn--fill slider--artwork__item--cta__btn" onClick={this.handleMoreImagesModalOpen}>Request Additional Images</button>
                </div>
            ))
            // Add CTA Dot
            thumbs.push((
                <ThumbDot key={`cta-dot`} d={{
                    GiantUrl: '../assets/img/moreImage/cta-dot.png'
                }} />
            ));
        }
        return (
            <React.Fragment>
                <div className="container container--spaced spacer--bottom">
                    <div className="section section--artwork-meta">
                        {
                            slides.length > 0 &&
                            <div className="artwork__view artwork--horizontal">
                                <Carousel thumbs={thumbs} height="calc(80vh - 9rem)">
                                    {slides}
                                </Carousel>
                                <div className="artwork__view__controls artwork__view__controls--inline">
                                    <FollowButton data={data} type="like" onChange={this.handleLikeArtwork}>
                                        <span className="art__btn-text">Like</span>
                                    </FollowButton>
                                    <FollowButton data={data} type="list" onChange={this.handleListArtworkAddModalOpen}>
                                        <span className="art__btn-text">Add to list</span>
                                    </FollowButton>
                                    <a href="#" onClick={this.handleShareModalOpen}>
                                        <span className="i i--share" />
                                        <span className="art__btn-text">Share</span>
                                    </a>
                                    {
                                        data.Dimensions && data.Dimensions.Height !== 0 && data.Dimensions.Width !== 0 &&
                                        <a href="#" onClick={this.handleVirtualInstallModalOpen}>
                                            <span className="i i--collector" />
                                            <span className="art__btn-text">Virtual Install</span>
                                        </a>
                                    }
                                    {
                                        data.Images.length > 1 &&
                                        <span className="slider--artwork__number">{this.state.currentImageSlide + 1} of {data.Images.length}</span>
                                    }
                                </div>
                            </div>
                        }
                        <div className="sidebar__container sidebar--artwork">
                            <div className="sidebar__box box--artist">
                                {
                                    data.Artist &&
                                    <div className="box__artist">
                                        <a href={`/artist/${data.Artist.Slug}`} className="box__artist__title">{data.Artist.Name}</a>
                                        <FollowButton data={data.Artist} onChange={this.handleArtistFollowChange} />
                                    </div>
                                }
                                <h1 className={`box__title ${data.TitleClass ? data.TitleClass : ''}`}>{data.Title}</h1>
                                <p className="box__text">{data.Medium}</p>
                                {
                                    data.Dimensions &&
                                    data.Dimensions.Display &&
                                    <p className="box__text">{data.Dimensions.Display.Formatted}</p>
                                }
                                <p className="box__text">{data.DisplayPrice}</p>


                                {
                                    data.Gallery &&
                                    <div className="btn--cont">
                                        {
                                            data.Available &&
                                            data.Gallery.AcceptsPayments &&
                                            <React.Fragment>
                                                <LinkButton config={{ color: 'dark', size: 'medium', style: 'fill' }} onClick={this.handleBuyNowModalOpen}>Purchase</LinkButton>
                                                <br />
                                                {
                                                    data.CanReceiveMarketplaceOffers &&
                                                    <LinkButton config={{ color: 'grey', size: 'medium', style: 'fill' }} onClick={this.handleMakeOfferModalOpen}>Make an Offer</LinkButton>
                                                }
                                            </React.Fragment>
                                        }
                                    </div>
                                }
                                {
                                    data.Gallery &&
                                    <React.Fragment>
                                        <span><br /></span>
                                        <div style={{ borderTop: '1px solid #ddd' }}></div>
                                        <span style={{ marginTop: '20px', fontWeight: 'bold' }}><br />Questions about this work?</span>
                                        <div className="btn--cont">
                                            <LinkButton config={{ color: 'light', size: 'medium', style: 'fill' }} onClick={this.handleInquireModalOpen} className={`btn--arrow ${ this.state.buttonArrowShow ? 'btn--arrow--active' : ''}`}>Inquire</LinkButton>
                                        </div>
                                    </React.Fragment>
                                }
                                {
                                    data.Gallery &&
                                    data.Gallery.Type != 2 &&
                                    <div className="box__gallery">
                                        <div className="box__gallery__info">
                                            <div className="box__gallery__info__meta">
                                                <a href={`/${data.Gallery.Type == 6 ? 'profile' : 'gallery'}/${data.Gallery.Slug}`} className="box__gallery__title">{data.Gallery.Company}</a>
                                                <a href={`/city/${data.Gallery.City}`} className="box__gallery__info__meta__location">{data.Gallery.Location}</a>
                                            </div>
                                            <FollowButton data={data.Gallery} onChange={this.handleGalleryFollowChange} />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container container--spaced">
                    {
                        data.Artist &&
                        <div className="section">
                            <div className="container">
                                {
                                    data.Artist.Image &&
                                    <div className="grid grid--2">
                                        <div className="artwork__artist--cover--cont">
                                            <a href={artistLink}>
                                                <div className="artwork__artist--cover" style={{ backgroundImage: `url('${data.Artist.Image.Url}')` }} />
                                            </a>
                                        </div>
                                    </div>
                                }
                                <div className="grid grid--10">
                                    <div className="artwork__artist--meta--cont">
                                        <a href={artistLink}>
                                            <h2 className="artwork__artist--name">{data.Artist.Name}</h2>
                                        </a>
                                        {
                                            data.Artist.City &&
                                            <p className="artwork__artist--city">
                                                <a href={`/city/${data.Artist.City}`}>{data.Artist.City}</a>
                                            </p>
                                        }
                                        {
                                            data.Artist.Bio &&
                                            <React.Fragment>
                                                <p className="artwork__artist--bio text--details read-more--cont"
                                                    id="artistBio"
                                                    style={{ height: this.state.artistBioExpanded ? this.state.artistBioHeightExpanded : this.state.artistBioHeightCollapsed }}
                                                    dangerouslySetInnerHTML={{__html: data.Artist.Bio}}>
                                                </p>
                                                <a href="#" className="read-more btn btn--underline" onClick={this.handleArtistBioToggle}>{this.state.artistBioExpanded ? 'Show Less' : 'Read More'}</a>
                                            </React.Fragment>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        data.Artist &&
                        <ArtworkSlider
                            className="container--artwork"
                            equal={false}
                            hideOnEmpty={true}
                            id="artist"
                            slideProps={{ height: 255, style: { minWidth: '115px' }, onLikeChange: this.handleArtworkLikeChange }}
                            titleContent={artistArtworkSliderTitleContent}
                            url={Artcloud.url.vendor.marketplace.artists.art.get(data.Artist.ArtistId)}
                            onParseResults={this.handleParseArtistArtworkResults} />
                    }
                    {
                        galleryArtworkSliderTitleContent != undefined &&
                        <ArtworkSlider
                            className="container--artwork"
                            equal={false}
                            hideOnEmpty={true}
                            id="gallery"
                            slideProps={{ height: 255, style: { minWidth: '115px' }, onLikeChange: this.handleArtworkLikeChange }}
                            titleContent={galleryArtworkSliderTitleContent}
                            url={Artcloud.url.vendor.marketplace.galleries.art.get(data.Gallery.GalleryId)}
                            onParseResults={this.handleParseGalleryArtworkResults} />
                    }
                    {
                        false &&
                        <ArtworkSlider
                            className="container--artwork"
                            equal={false}
                            hideOnEmpty={true}
                            id="related"
                            slideProps={{ height: 255, style: { minWidth: '115px' }, onLikeChange: this.handleArtworkLikeChange }}
                            title="Related artworks"
                            titleSmall={true}
                            url={Artcloud.url.vendor.marketplace.art.related.get(data.ArtId)}
                            onParseResults={this.handleParseRelatedArtworkResults} />
                    }
                    {
                        this.state.Recents &&
                        this.state.Recents.Data &&
                        this.state.Recents.Data.length &&
                        <ArtworkSlider
                            className="container--artwork"
                            equal={false}
                            hideOnEmpty={true}
                            id="viewed"
                            slideProps={{ height: 255, style: { minWidth: '115px' }, onLikeChange: this.handleArtworkLikeChange }}
                            title="Viewed recently"
                            titleSmall={true}
                            url={Artcloud.url.vendor.marketplace.graph.inventory.list()}
                            q={(() => {
                                let ids = {};
                                this.state.Recents.Data.map((e, i) => {
                                    ids[`ids[${i}]`] = e.ArtId;
                                });
                                return ids;
                            })()}
                            onParseResults={this.handleParseRecentArtworkResults}
                        />
                    }
                </div>
                {
                    this.state.artworkZoomModal &&
                    this.state.artworkZoomModal.visible &&
                    this.props.data.Images &&
                    this.state.artworkZoomModal.imageIndex < this.props.data.Images.length &&
                    <ArtworkZoomModal
                        data={this.props.data}
                        image={this.props.data.Images[this.state.artworkZoomModal.imageIndex]}
                        onClose={this.handleArtworkZoomClose}
                        onListArtworkAdd={this.handleListArtworkAddModalOpen}
                        onShare={this.handleShareModalOpen} />
                }
                {
                    this.state.roomViewModal &&
                    this.state.roomViewModal.visible &&
                    this.props.data.Images &&
                    this.state.roomViewModal.imageIndex < this.props.data.Images.length &&
                    <VirtualInstallModal
                        data={this.props.data}
                        image={this.props.data.Images[this.state.roomViewModal.imageIndex]}
                        onClose={this.handleVirtualInstallModalClose}
                        onListArtworkAdd={this.handleListArtworkAddModalOpen}
                        onShare={this.handleShareModalOpen} />
                }
                {
                    this.state.shareModal &&
                    this.state.shareModal.visible &&
                    <ArtworkShareModal data={this.props.data} nested={this.state.shareModal.nested} onClose={this.handleShareModalClose} />
                }
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} nested={this.state.listArtworkAddModal.nested} onClose={this.handleListArtworkAddModalClose} />
                }
                {
                    this.state.inquireModal &&
                    <ArtworkInquireModal
                        initialState={{ Email: this.state.Email, Message: this.state.Message, Name: this.state.Name }}
                        loading={this.state.inquiring}
                        onSubmit={this.handleInquire}
                        onClose={this.handleInquireModalClose} />
                }
                {
                    this.state.moreImagesModal &&
                    <ArtworkInquireModal
                        initialState={{ Email: this.state.Email, Message: this.state.Message, Name: this.state.Name }}
                        loading={this.state.inquiring}
                        onSubmit={this.handleInquire}
                        onClose={this.handleMoreImagesModalClose} />
                }
                {
                    this.state.buyNowModal &&
                    <BuyNowModal data={this.props.data} onClose={this.handleBuyNowModalClose} />
                }
                {
                    this.state.offerModal &&
                    <OfferModal data={this.props.data} onClose={this.handleMakeOfferModalClose} />
                }
            </React.Fragment>
        );
    }
}
const Art = forResource(_Art, Artcloud.url.vendor.marketplace.art.getid);

// region INQUIRE
class ArtworkInquireModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (grecaptcha) {
            grecaptcha.render('example1', {
                'sitekey': '6Ldz5BMUAAAAABRCXCk2a1Yxwhu7GLrbl7RDgKJZ'
            });
        }
    }

    render() {
        return (
            <Popup className={'popup--inquire'} type='container' onClose={this.props.onClose}>
                <InquireForm {...this.props} />
            </Popup>
        )
    }
}

// region SHARE
class ArtworkShareModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this._handleInputRef = this._handleInputRef.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.handleResetShareState = this.handleResetShareState.bind(this);
        this.handleShareEmail = this.handleShareEmail.bind(this);
        this.handleShareEmailSubmit = this.handleShareEmailSubmit.bind(this);
        this.handleShareFacebook = this.handleShareFacebook.bind(this);
        this.handleShareSMS = this.handleShareSMS.bind(this);
        this.handleShareSMSSubmit = this.handleShareSMSSubmit.bind(this);
        this.handleShareTwitter = this.handleShareTwitter.bind(this);
    }

    componentDidMount() {
        let titleHeight;
        const titleElement = document.getElementById('headerTitle');
        if (titleElement) {
            titleHeight = titleElement.offsetHeight;
        }
        this.setState({
            titleHeight: titleHeight
        });
    }

    _handleInputRef(ref) {
        this.inputRef = ref;
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleInputFocus() {
        if (!this.inputRef) {
            return;
        }
        this.inputRef.select();
    }

    handleInputMouseUp() {
        return false;
    }

    handleResetShareState(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            completeEmail: undefined,
            completeSMS: undefined,
            shareEmail: undefined,
            shareSMS: undefined
        });
    }

    handleShareEmail(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            shareEmail: true
        });
    }

    handleShareEmailSubmit(data) {
        Artcloud.api.post(Artcloud.url.vendor.marketplace.art.shares.emails.post(this.props.data.ArtId), { Email: data.Email });

        this.setState({
            completeEmail: true,
            shareEmail: undefined
        });
    }

    handleShareFacebook(event) {
        if (event) {
            event.preventDefault();
        }
        if (!FB) {
            return;
        }
        FB.ui({
            method: 'share',
            href: window.location.href
        }, function () { });
    }

    handleShareSMS(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            shareSMS: true
        });
    }

    handleShareSMSSubmit(data) {
        Artcloud.api.post(Artcloud.url.vendor.marketplace.art.shares.sms.post(this.props.data.ArtId), { Number: data.Number });

        this.setState({
            completeSMS: true,
            shareSMS: undefined
        });
    }

    handleShareTwitter(event) {
        if (event) {
            event.preventDefault();
        }
        const uri = 'https://twitter.com/share?url=' + window.location.href;
        window.open(uri, '_blank');
    }

    render() {
        const data = this.props.data || {};
        const href = window.location.href;

        let className = 'popup--share';
        if (this.state.completeEmail || this.state.completeSMS || this.state.shareEmail || this.state.shareSMS) {
            className += ' popup--share--extra-active';
        }
        let emailClassName = 'share--extra share--open share--mail';
        if (this.state.shareEmail && !this.state.completeEmail) {
            emailClassName += ' share--extra--active';
        }
        let smsClassName = 'share--extra share--sms';
        if (this.state.shareSMS && !this.state.completeSMS) {
            smsClassName += ' share--extra--active';
        }
        let completeClassName = 'share__thankyou';
        if (this.state.completeEmail || this.state.completeSMS) {
            completeClassName += ' share__thankyou--active';
        }
        let title;
        if (this.state.completeEmail) {
            title = 'Email Sent';
        } else if (this.state.completeSMS) {
            title = 'SMS Sent';
        } else {
            title = `Share ${data.Title}`;
        }
        return (
            <Popup className={className} nested={this.props.nested} type='container' onClose={this.handleClose}>
                <a href="#" className="share__back share--back" onClick={this.handleResetShareState}>
                    <span className="i i--rounded-back" />
                </a>
                <h5 id='headerTitle' className="form--signup__header">{title}</h5>
                <div className="form__inner">
                    <div className="share--main">
                        <Input
                            config={{ color: 'light', iconPlacement: 'il', size: 'medium', style: 'outline' }}
                            type="text"
                            value={href}
                            onFocus={this.handleInputFocus}
                            onMouseUp={this.handleInputMouseUp}
                            onRef={this._handleInputRef}>
                            <span className="i i--link" />
                        </Input>
                        <div className="btn--grid">
                            <div className="btn--grid__item">
                                <a href="#" className="btn btn--share" onClick={this.handleShareFacebook}>
                                    <span className="i i--rounded-facebook" />
                                    facebook
                                </a>
                            </div>
                            <div className="btn--grid__item">
                                <a href="#" className="btn btn--share" onClick={this.handleShareTwitter}>
                                    <span className="i i--rounded-twitter" />
                                    twitter
                                </a>
                            </div>
                            <div className="btn--grid__item">
                                <a href={`https://www.pinterest.com/pin/create/button/?url=${href}&media=${data.Images && data.Images.length > 0 ? data.Images[0].GiantUrl : ''}&description=${data.Title}`}
                                    className="btn btn--share"
                                    data-pin-custom="true"
                                    data-pin-do="buttonPin"
                                    target="_blank">
                                    <span className="i i--rounded-pinterest" />
                                    pinterest
                                </a>
                            </div>
                            <div className="btn--grid__item share--open" data-share="sms">
                                <a href="#" className="btn btn--share text--center" onClick={this.handleShareSMS}>
                                    <span className="i i--rounded-chat" />
                                    SMS
                                </a>
                            </div>

                            <div className="btn--grid__item share--open" data-share="mail" style={{ width: '100%' }}>
                                <a href="#" className="btn btn--share text--center" onClick={this.handleShareEmail}>
                                    <span className="i i--rounded-mail" />
                                    email
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={smsClassName} style={{ top: (this.state.titleHeight + 105) + 'px' }}>
                        <ShareSMSForm data={data} onSubmit={this.handleShareSMSSubmit} />
                    </div>
                    <div className={emailClassName} style={{ top: (this.state.titleHeight + 105) + 'px' }}>
                        <ShareEmailForm data={data} onSubmit={this.handleShareEmailSubmit} />
                    </div>
                    <div className={completeClassName} style={{ top: (this.state.titleHeight + 105) + 'px' }}>
                        <p className="form__info">Thank you for sharing!</p>
                        <Arrows
                            config={{ color: 'light' }}
                            display="Share with more people"
                            form={true}
                            renderAsLink={true}
                            onClick={this.handleResetShareState} />
                    </div>
                </div>
            </Popup>
        );
    }
}

function _ShareEmailForm(props) {
    return (
        <React.Fragment>
            <p className="form__info">Share {props.data.Title} through email. Add an email address below and send.</p>
            <Input
                config={{ color: 'light', size: 'medium', style: 'outline' }}
                name="Email"
                placeholder="Email address"
                required
                type="email"
                value={props.state.Email}
                onChange={props.onChange} />
            <Arrows
                config={{ color: 'light' }}
                display="Send email"
                form={true}
                type="submit" />
        </React.Fragment>
    );
}
const ShareEmailForm = withSubmission(_ShareEmailForm);

function _ShareSMSForm(props) {
    return (
        <React.Fragment>
            <p className="form__info">Share {props.data.Title} through SMS. Add a number below and send.</p>
            <Input
                config={{ color: 'light', size: 'medium', style: 'outline' }}
                name="Number"
                placeholder="Phone Number"
                required
                type="text"
                value={props.state.Number}
                onChange={props.onChange} />
            <Arrows
                config={{ color: 'light' }}
                display="Send SMS"
                form={true}
                type="submit" />
        </React.Fragment>
    );
}
const ShareSMSForm = withSubmission(_ShareSMSForm);

// region ZOOM
class ArtworkZoomModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleClose = this.handleClose.bind(this);
        this.handleListArtworkAdd = this.handleListArtworkAdd.bind(this);
        this.handleShare = this.handleShare.bind(this);
    }

    componentDidMount() {
        window.acpanzoom = {
            instance: Panzoom(document.getElementById('zoomImage'))
        };
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleListArtworkAdd() {
        if (this.props.onListArtworkAdd) {
            this.props.onListArtworkAdd('nested');
        }
    }

    handleShare(event) {
        if (this.props.onShare) {
            this.props.onShare(event, 'nested');
        } else if (event) {
            event.preventDefault();
        }
    }

    render() {
        const data = this.props.data || {};
        return (
            <Popup backgroundClick={false} className='popup--img' onClose={this.handleClose}>
                <div>
                    <div className="artwork__view artwork--vertical">
                        <div className="artwork__view__controls">
                            <FollowButton data={data} type="like" onChange={this.handleListArtworkAdd}>
                                <span className="art__btn-text">Add to list</span>
                            </FollowButton>
                            <a href="#" onClick={this.handleShare}>
                                <span className="i i--share"></span>
                                <span className="art__btn-text">Share</span>
                            </a>
                        </div>
                        <div className="panzoom__cont">
                            <div className="panzoom__parent">
                                <div className="panzoom__img" id="zoomImage">
                                    <img src={this.props.image ? this.props.image.GiantUrl : undefined} alt={data.Title} />
                                </div>
                            </div>

                            <div className="panzoom__controls">
                                <button className="panzoom__out" id="zoomOut" onClick={() => {
                                    window.acpanzoom.instance.zoomOut();
                                    document.getElementById('zoomSlider').value = window.acpanzoom.instance.getScale() + '';
                                }}>-</button>
                                <input
                                    className="panzoom__slider panzoom__input"
                                    id="zoomSlider"
                                    min="0.5"
                                    max="4"
                                    step="0.1"
                                    defaultValue="1"
                                    type="range"
                                    onInput={(event) => {
                                        window.acpanzoom.instance.zoom((event.target).valueAsNumber)
                                    }}
                                    onChange={(event) => {
                                        window.acpanzoom.instance.zoom((event.target).valueAsNumber)
                                    }}/>
                                <button className="panzoom__in" id="zoomIn" onClick={() => {
                                    window.acpanzoom.instance.zoomIn();
                                    document.getElementById('zoomSlider').value = window.acpanzoom.instance.getScale() + '';
                                }}>+</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

// region VIRTUAL INSTALL
class VirtualInstallModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // room state
            canvasHeight: 0,
            canvasWidth: 0,
            imageHref: '#',
            selectedFile: '../assets/img/roomview/room.jpg',
            loading: true,
            isVertical: undefined,

            // artwork state
            active: false,
            artworkConversionConstant: 1,
            artworkHeight: 0,
            artworkWidth: 0,
            currentX: 0,
            currentY: 0,
            initialX: 0,
            initialY: 0,

            // guide state
            guideActive: false,
            guideVisible: true,
            guideLeftHandleActive: false,
            guideRightHandleActive: false,
            guideInitialX: 0,
            guideInitialWidth: 0,
            guideWidthInput: 0,
            guideWidthUnit: '',
            guideCurrentWidth: 0,
            guideCurrentX: 0,
            guideCurrentY: 0,
            activateGuide: false
        };

        this.checkImage = this.checkImage.bind(this);
        this.drawRoom = this.drawRoom.bind(this);
        this.drawRoomWithNewArtworkSize = this.drawRoomWithNewArtworkSize.bind(this);
        this.getMousePosition = this.getMousePosition.bind(this);
        this.getInitialDimensions = this.getInitialDimensions.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleGuidePopupClose = this.handleGuidePopupClose.bind(this);
        this.handleGuideWidthInputChange = this.handleGuideWidthInputChange.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.loadImgs = this.loadImgs.bind(this);

        this.canvasRef = React.createRef(null);
        this.downloadRef = React.createRef(null);
        this.screenRef = React.createRef(null);

        this.artwork = new Image();
        this.ctx = {};
        this.room = new Image();
    }

    componentDidMount() {
        // init canvas
        const canvas = this.canvasRef.current;
        this.ctx = canvas.getContext("2d");

        // add room image
        const roomPathAndElem = [this.state.selectedFile, this.room];

        // add artwork image
        const artworkPathAndElem = [this.props.image ? `${window.location.origin}/img?path=${this.props.image.GiantUrl}` : undefined, this.artwork];

        this.loadImgs(roomPathAndElem, artworkPathAndElem).then(() => {
            this.getInitialDimensions(this.drawRoom);
        });
    }

    checkImage(path, elem) {
        return new Promise(resolve => {
            elem.onload = () => resolve({ path, status: 'ok' });
            elem.onerror = () => resolve({ path, status: 'error' });
            elem.src = path;
        });
    }

    drawRoom() {
        const {
            artworkWidth, artworkHeight, canvasWidth, canvasHeight,
            currentX, currentY, guideCurrentWidth, guideCurrentX, guideCurrentY,
            guideVisible
        } = this.state;

        // draw room
        this.ctx.drawImage(this.room, 0, 0, canvasWidth, canvasHeight);

        if (guideVisible) {
            // draw rounded guide background
            const radius = 7;
            const rectX = guideCurrentX - 7;
            const rectY = guideCurrentY - 30;
            const rectW = guideCurrentWidth + 14;
            const rectH = 44;


            this.ctx.beginPath();
            this.ctx.moveTo(rectX + radius, rectY);
            this.ctx.lineTo(rectX + rectW - radius, rectY);
            this.ctx.quadraticCurveTo(rectX + rectW, rectY, rectX + rectW, rectY + radius);
            this.ctx.lineTo(rectX + rectW, rectY + rectH - radius);
            this.ctx.quadraticCurveTo(rectX + rectW, rectY + rectH, rectX + rectW - radius, rectY + rectH);
            this.ctx.lineTo(rectX + radius, rectY + rectH);
            this.ctx.quadraticCurveTo(rectX, rectY + rectH, rectX, rectY + rectH - radius);
            this.ctx.lineTo(rectX, rectY + radius);
            this.ctx.quadraticCurveTo(rectX, rectY, rectX + radius, rectY);
            this.ctx.closePath();
            this.ctx.fillStyle = 'rgba(0,0,0,.5)';
            this.ctx.strokeStyle = 'rgba(0,0,0,.5)';
            this.ctx.fill();

            // draw guide
            this.ctx.beginPath();

            // span line 
            this.ctx.moveTo(guideCurrentX, guideCurrentY);
            this.ctx.lineTo(guideCurrentX + guideCurrentWidth, guideCurrentY);

            // left handle
            this.ctx.moveTo(guideCurrentX, guideCurrentY - 7);
            this.ctx.lineTo(guideCurrentX, guideCurrentY + 7);

            // right handle
            this.ctx.moveTo(guideCurrentX + guideCurrentWidth, guideCurrentY - 7);
            this.ctx.lineTo(guideCurrentX + guideCurrentWidth, guideCurrentY + 7);

            this.ctx.strokeStyle = '#fff';
            this.ctx.stroke();

            // add input width
            this.ctx.font = "20px Roboto";
            this.ctx.fillStyle = "#fff";
            this.ctx.fillText(
                this.state.guideWidthInput.toString() + ' ' + this.state.guideWidthUnit,
                guideCurrentX - 20 + guideCurrentWidth / 2,
                guideCurrentY - 7
            );
        }

        // add shadow and draw artwork
        this.ctx.shadowColor = 'rgba(0,0,0,.25)';
        this.ctx.shadowBlur = 5;
        this.ctx.shadowOffsetX = -5;
        this.ctx.shadowOffsetY = 5;

        // The original aspect ratio of the uploaded image is respected to the 
        // avoid distortion. It is assumed that the upload images are approximately
        // the same aspect ratio as the dimensions of original the artwork
        this.ctx.drawImage(this.artwork, currentX, currentY, artworkWidth, artworkWidth * (this.artwork.height / this.artwork.width));
    }

    drawRoomWithNewArtworkSize() {
        const dimensions = this.props.data.Dimensions || { Width: 36, Height: 36, Metric: 0 };
        const {
            guideCurrentWidth, guideWidthInput, currentX, currentY,
            artworkWidth, artworkHeight, artworkConversionConstant
        } = this.state;

        const newArtworkWidth = dimensions.Width * guideCurrentWidth / artworkConversionConstant / guideWidthInput;
        const newArtworkHeight = dimensions.Height * guideCurrentWidth / artworkConversionConstant / guideWidthInput;
        const newArtworkX = currentX + ((artworkWidth - newArtworkWidth) / 2);
        const newArtworkY = currentY + ((artworkHeight - newArtworkHeight) / 2);

        this.setState({
            artworkWidth: newArtworkWidth,
            artworkHeight: newArtworkHeight,
            currentX: newArtworkX,
            currentY: newArtworkY
        }, this.drawRoom);
    }

    getInitialDimensions(callback) {
        // get art and screen dimensions
        const dimensions = this.props.data.Dimensions  || { Width: 36, Height: 36, Metric: 0 };;
        const screenHeight = this.screenRef.current.clientHeight;
        const screenWidth = this.screenRef.current.clientWidth;
        const screenAspectRatio = screenWidth / screenHeight;

        // get constant / unit
        let unit = 'in';
        let conversionConstant = 1;

        switch (dimensions.Metric) {
            // inches
            case 0:
                conversionConstant = 1;
                break;
            // cm
            case 1:
                conversionConstant = 2.54;
                break;
            // feet
            case 2:
                conversionConstant = 0.0833;
                break;
            default:
                break;
        }

        // There are two possible guide lengths here: 70in (5.8ft) and 120in (10ft)
        // Artworks with less than 5.8ft height and 13ft width are given the 7ft guide
        // Artworks greater are given the 10ft guide
        // largest comfortably supported image is max 9ft height and max 19ft width
        let initialGuideWidthInput = (
            dimensions.Width / conversionConstant >= 156 || 
            dimensions.Height / conversionConstant >= 70
        ) ? 120 : 84;

        // get room size
        const roomAspectRatio = this.room.width / this.room.height;
        const isVertical = roomAspectRatio < screenAspectRatio;
        let roomWidth = 0;
        let roomHeight = 0;

        if (isVertical) {
            roomWidth = roomAspectRatio * screenHeight;
            roomHeight = screenHeight;
        } else {
            roomWidth = screenWidth;
            roomHeight = screenWidth / roomAspectRatio;
        }

        // get guide size
        const guideWidth = roomWidth / 2;
        const guideX = roomWidth / 4;
        const guideY = roomHeight * 3 / 4;

        // get artwork size
        const artworkWidth = dimensions.Width * guideWidth / conversionConstant / initialGuideWidthInput;
        const artworkHeight = dimensions.Height * guideWidth / conversionConstant / initialGuideWidthInput;
        const artworkX = roomWidth / 2 - artworkWidth / 2;
        const artworkY = roomHeight * 3 / 8 - artworkHeight / 2;

        this.setState({
            artworkConversionConstant: conversionConstant,
            artworkHeight: artworkHeight,
            artworkWidth: artworkWidth,
            canvasWidth: roomWidth,
            canvasHeight: roomHeight,
            currentX: artworkX,
            currentY: artworkY,
            isVertical: isVertical,
            guideCurrentWidth: guideWidth,
            guideWidthInput: initialGuideWidthInput,
            guideWidthUnit: unit,
            guideCurrentX: guideX,
            guideCurrentY: guideY,
        }, callback);
    }

    getMousePosition(event) {
        const screenHeight = this.screenRef.current.clientHeight;
        const screenWidth = this.screenRef.current.clientWidth;

        const { currentX, currentY, artworkWidth, artworkHeight,
            canvasWidth, canvasHeight, isVertical, guideCurrentWidth,
            guideCurrentX, guideCurrentY } = this.state;

        const xCorrection = (screenWidth - canvasWidth) / 2;
        const yCorrection = (screenHeight - canvasHeight) / 2;

        let clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        let clientY = event.clientY ? event.clientY : event.touches[0].clientY;

        clientX = isVertical ? clientX - xCorrection : clientX;
        clientY = isVertical ? clientY : clientY - yCorrection;

        if (
            clientX > currentX &&
            clientX < currentX + artworkWidth &&
            clientY > currentY &&
            clientY < currentY + artworkHeight
        ) {
            return 'artwork';
        } else if (
            clientX > guideCurrentX + 7 &&
            clientX < guideCurrentX + guideCurrentWidth - 7 &&
            clientY > guideCurrentY - 7 &&
            clientY < guideCurrentY + 7
        ) {
            return 'guide';
        } else if (
            clientX > guideCurrentX - 7 &&
            clientX < guideCurrentX + 7 &&
            clientY > guideCurrentY - 7 &&
            clientY < guideCurrentY + 7
        ) {
            return 'guideLeftHandle';
        } else if (
            clientX > guideCurrentX + guideCurrentWidth - 7 &&
            clientX < guideCurrentX + guideCurrentWidth + 7 &&
            clientY > guideCurrentY - 7 &&
            clientY < guideCurrentY + 7
        ) {
            return 'guideRightHandle';
        } else {
            return false;
        }
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleFileChange(event) {
        event.preventDefault();
        this.setState(
            {
                selectedFile: URL.createObjectURL(event.target.files[0]),
                loading: true,
                activateGuide: true,
                showGuidePopup: true
            },
            () => {
                const roomPathAndElem = [this.state.selectedFile, this.room];

                this.loadImgs(roomPathAndElem).then(() => {
                    this.getInitialDimensions(this.drawRoom);
                });
            }
        );
    }

    handleGuideWidthInputChange(event, drawRoom = true) {
        event.preventDefault();
        const guideWidth = parseInt(event.target.value);

        this.setState(
            {
                guideWidthInput: !Number.isNaN(guideWidth) && guideWidth > 0 ? guideWidth : ''
            },
            !Number.isNaN(guideWidth) && guideWidth > 0 && drawRoom ? this.drawRoomWithNewArtworkSize : null
        )
    }

    handleGuidePopupClose(event) {
        event.preventDefault();
        this.setState(
            {
                showGuidePopup: false
            },
            !Number.isNaN(this.state.guideWidthInput) && this.state.guideWidthInput > 0 ? this.drawRoomWithNewArtworkSize : null
        );
    }

    handleMouseDown(event) {
        /* initialX is something different in each context used purely for calculation.
            artwork, guide, guideLeftHandle: distance from left edge of window to room left
            guideRightHandle: distance from left edge of window to guide left handle
        */
        const clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        const clientY = event.clientY ? event.clientY : event.touches[0].clientY;

        if (this.getMousePosition(event) === 'artwork') {
            this.setState({
                initialX: clientX - this.state.currentX,
                initialY: clientY - this.state.currentY,
                active: true
            });
        } else if (this.getMousePosition(event) === 'guide' && this.state.activateGuide) {
            this.setState({
                initialX: clientX - this.state.guideCurrentX,
                initialY: clientY - this.state.guideCurrentY,
                guideActive: true
            });
        } else if (this.getMousePosition(event) === 'guideLeftHandle' && this.state.activateGuide) {
            this.setState({
                initialX: clientX - this.state.guideCurrentX,
                guideInitialX: this.state.guideCurrentX,
                guideInitialWidth: this.state.guideCurrentWidth,
                guideLeftHandleActive: true
            });
        } else if (this.getMousePosition(event) === 'guideRightHandle' && this.state.activateGuide) {
            this.setState({
                initialX: clientX - this.state.guideCurrentWidth,
                guideRightHandleActive: true
            });
        }
    }

    handleMouseUp(event) {
        if (this.state.active || this.state.guideActive || this.state.guideLeftHandleActive || this.state.guideRightHandleActive) {
            this.setState({
                active: false,
                guideActive: false,
                guideLeftHandleActive: false,
                guideRightHandleActive: false
            });
        }
    }

    handleMouseMove(event) {
        const clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        const clientY = event.clientY ? event.clientY : event.touches[0].clientY;

        if (this.state.active) {
            this.setState({
                currentX: clientX - this.state.initialX,
                currentY: clientY - this.state.initialY
            }, this.drawRoom);
        } else if (this.state.guideActive) {
            this.setState({
                guideCurrentX: clientX - this.state.initialX,
                guideCurrentY: clientY - this.state.initialY
            }, this.drawRoom);
        } else if (this.state.guideLeftHandleActive) {
            this.setState({
                guideCurrentX: clientX - this.state.initialX,
                guideCurrentWidth: this.state.guideInitialWidth + this.state.initialX + this.state.guideInitialX - clientX
            }, this.drawRoomWithNewArtworkSize);
        } else if (this.state.guideRightHandleActive) {
            this.setState({
                guideCurrentWidth: clientX - this.state.initialX
            }, this.drawRoomWithNewArtworkSize);
        }
    }

    handleSave() {
        this.setState(
            {
                guideVisible: false
            },
            () => {
                this.drawRoom();
                var image = this.canvasRef.current
                    .toDataURL("image/png")
                    .replace("image/png", "image/octet-stream");

                this.setState(
                    {
                        imageHref: image,
                        guideVisible: true
                    },
                    this.drawRoom
                );
            }
        );
    }

    loadImgs(...pathsAndElems) {
        return Promise.all(
            pathsAndElems.map(
                pathAndElem => this.checkImage(...pathAndElem)
            )
        ).then(() => this.setState({ loading: false }));
    }

    render() {
        const data = this.props.data || {};

        return (
            <React.Fragment>
                <Popup backgroundClick={false} className='popup--img popup--img--room-view' onClose={this.handleClose}>
                    <div>
                        <div className="artwork__view__controls--room-view">
                            {this.state.activateGuide && <React.Fragment>
                                <span className="artwork__view__controls--room-view__label">Guide Width: </span>
                                <span className="artwork__view__controls--room-view__input-container">
                                    <input
                                        className="artwork__view__controls--room-view__input-container__input"
                                        type="text"
                                        value={this.state.guideWidthInput}
                                        onChange={this.handleGuideWidthInputChange} />
                                    <span
                                        className="artwork__view__controls--room-view__input-container__unit">
                                        {this.state.guideWidthUnit}
                                    </span>
                                </span>
                            </React.Fragment>}
                            <label
                                htmlFor="file"
                                className="artwork__view__controls--room-view__btn btn btn--white">
                                Choose Background Image
                            </label>
                            <input
                                className="artwork__view__controls--room-view__input--file"
                                name="file"
                                type="file"
                                id="file"
                                accept="image/*"
                                onChange={this.handleFileChange} />
                            <a
                                ref={this.downloadRef}
                                download={data.Title + '.png'}
                                href={this.state.imageHref}
                                className="artwork__view__controls--room-view__btn btn btn--white"
                                onClick={this.handleSave}>
                                Save
                            </a>
                        </div>
                        <div className="artwork__view artwork--vertical artwork--vertical--room-view"
                            ref={this.screenRef}>
                            {this.state.loading && <div className="artwork__view__loading">loading images ...</div>}
                            <canvas
                                style={{
                                    visibility: this.state.loading ? 'hidden' : 'visible'
                                }}
                                onMouseDown={this.handleMouseDown}
                                onTouchStart={this.handleMouseDown}
                                onMouseUp={this.handleMouseUp}
                                onTouchEnd={this.handleMouseUp}
                                onMouseMove={this.handleMouseMove}
                                onTouchMove={this.handleMouseMove}
                                width={this.state.canvasWidth}
                                height={this.state.canvasHeight}
                                id="virtual-install"
                                className="artwork__view__room-view"
                                ref={this.canvasRef}>
                            </canvas>
                        </div>
                    </div>
                </Popup>
                {this.state.showGuidePopup &&
                    <Popup
                        className="popup--guide"
                        onClose={this.handleGuidePopupClose}
                        type='container'>
                        <div>
                            <h5 id='headerTitle' className="form--signup__header">Set Surface Mounting Width</h5>
                            <p>
                                What is the physical width(in) of the mounting surface in this photo?
                            </p>
                            <span className="artwork__view__controls--room-view__input-container popup--guide__input">
                                <input
                                    className="artwork__view__controls--room-view__input-container__input"
                                    type="text"
                                    value={this.state.guideWidthInput}
                                    onChange={event => this.handleGuideWidthInputChange(event, false)}
                                />
                                <span
                                    className="artwork__view__controls--room-view__input-container__unit">
                                    {this.state.guideWidthUnit}
                                </span>
                            </span>
                            <a
                                className="artwork__view__controls--room-view__btn btn btn--white popup--guide__input"
                                onClick={this.handleGuidePopupClose}>
                                Set Width
                            </a>
                            <p>
                                After setting the width, move and resize the guide to the width of the mounting surface in the background image.
                            </p>
                        </div>
                    </Popup>
                }
            </React.Fragment>
        );
    }
}

// region BUY NOW
let _BuyNowInst;
class _BuyNowModal extends React.Component {
    constructor(props) {
        super(props);

        let email, firstName, lastName;
        const user = Artcloud.auth.user;
        if (user) {
            email = user.Email;
            firstName = user.FirstName;
            lastName = user.LastName;
        }
        this.state = {
            Email: email,
            FirstName: firstName,
            LastName: lastName
        };

        this.inputConfig = {
            color: 'light',
            size: 'medium',
            style: 'outline'
        };

        this._handleBuyNow = this._handleBuyNow.bind(this);
        this._handleError = this._handleError.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        _BuyNowInst = true;
    }

    componentWillUnmount() {
        _BuyNowInst = undefined;
    }

    _handleBuyNow(token, data, callback) {
        const component = this;
        const postData = {
            AddressLineOne: data.AddressLineOne,
            AddressLineTwo: data.AddressLineTwo,
            City: data.City,
            Country: data.Country,
            EditionIds: [component.props.data.EditionId],
            Email: data.Email,
            FirstName: data.FirstName,
            GalleryId: component.props.data.Gallery.GalleryId,
            LastName: data.LastName,
            Notes: data.Notes,
            Phone: data.Phone,
            State: data.State,
            Token: token,
            Zip: data.Zip
        };
        if (window && Cookies) {
            postData.Referrer = Cookies.get(Artcloud.auth.keys.cookies.referrer)
            postData.Utm = Cookies.get(Artcloud.auth.keys.cookies.utm)
        }
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.art.buy(),
            postData,
            function (responseData) {
                component._logTransaction(responseData);

                if (!_BuyNowInst) {
                    return;
                }
                component.setState({
                    loading: false
                });
                if (callback) {
                    callback(true, 'Thank you for your purchase. A confirmation email is on the way!');
                }
            },
            function (jqXHR) {
                component._handleError(jqXHR, callback);
            }
        );
    }

    _handleError(jqXHR, callback) {
        if (!_BuyNowInst) {
            return;
        }
        this.setState({
            loading: false
        });
        if (callback) {
            callback(false, 'There was an error with your request. Please wait a moment and try again.', jqXHR);
        }
    };

    _logTransaction(transactionData) {
        const data = this.props.data;
        if (!data || !window.gtag) {
            return;
        }
        const id = transactionData.InvoiceId;
        const revenue = transactionData.Total;
        let tax = 0;
        if (transactionData.Tax) {
            tax = transactionData.Tax.Amount;
        }
        const price = (revenue - tax);

        let affiliation;
        if (data.Gallery) {
            affiliation = data.Gallery.Company;
        }
        try {
            gtag('event', 'purchase', {
                transaction_id: id,
                affiliation: affiliation,
                value: revenue,
                currency: 'USD',
                tax: tax,
                items: [
                    {
                        item_name: data.Title,
                        item_id: data.ArtId,
                        price: price,
                        quantity: 1
                    }
                ]
            });
        } catch (e) { }
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSubmit(data, callback) {
        if (this.state.loading) {
            return;
        }
        const component = this;
        component.setState({
            loading: true
        });
        component.props.onStripeTokenRequest(
            data,
            function (success, responseData) {
                if (!success) {
                    component._handleError(responseData, callback);
                } else {
                    component._handleBuyNow(responseData.id, data, callback);
                }
            }
        );
    }

    render() {
        const data = this.props.data || {};
        let image;
        if (data.Images && data.Images.length) {
            image = data.Images[0].MediumUrl;
        }
        let company;
        if (data.Gallery) {
            company = data.Gallery.Company;
        }
        return (
            <Popup className="form__container form--buy popup--buy" type="popup" onClose={this.handleClose}>
                <div className="popup--buy__inn">
                    <div className="form__artwork">
                        <div className="form__artwork__img">
                            <img src={image} alt={data.Title} />
                        </div>
                        <div className="art__info">
                            {
                                data.Artist &&
                                <span className="art__user">{data.Artist.Name}</span>
                            }
                            <span className="art__title">{data.Title}</span>
                            <span className="art__details">
                                {
                                    data.Dimensions &&
                                    data.Dimensions.Display &&
                                    <span>{data.Dimensions.Display.Formatted}</span>
                                }
                                <span>{data.DisplayPrice}</span>
                                <span>{company}</span>
                            </span>
                        </div>
                    </div>
                    <p className="form__text">Please enter your credit card and shipping information. A representative{company && company.length ? ' from ' + company : ''} will be in touch to discuss shipping costs before your card is charged.</p>
                    <BuyNowForm inputConfig={this.inputConfig} loading={this.state.loading} onSubmit={this.handleSubmit} />
                    <div className="form__footer">
                        <p>You will receive an email confirmation</p>
                    </div>
                    {
                        this.state.loading &&
                        <LoadingFull style={{ backgroundColor: '#222' }} />
                    }
                </div>
            </Popup>
        );
    }
}
const BuyNowModal = withStripeTokenRequest(_BuyNowModal);

function _BuyNowForm(props) {
    return (
        <React.Fragment>
            <div className="form--compact">
                <div className="input--double">
                    <Input
                        config={{ color: 'light', size: 'medium' }}
                        disabled={props.loading || props.success}
                        name="FirstName"
                        placeholder="First Name"
                        required
                        type="text"
                        value={props.state.FirstName}
                        onChange={props.onChange} />
                    <Input
                        config={{ color: 'light', size: 'medium' }}
                        disabled={props.loading || props.success}
                        name="LastName"
                        placeholder="Last Name"
                        required
                        type="text"
                        value={props.state.LastName}
                        onChange={props.onChange} />
                </div>
                <Input
                    config={{ color: 'light', size: 'medium' }}
                    disabled={props.loading || props.success}
                    maxLength={16}
                    name="PaymentAccount"
                    placeholder="Card Number"
                    required
                    type="text"
                    value={props.state.PaymentAccount}
                    onChange={props.onChange} />
                <div className="input--double">
                    <Input
                        config={props.inputConfig}
                        disabled={props.loading || props.success}
                        name="Expiration"
                        placeholder="Expiration Date (mm/yy)"
                        required
                        type="text"
                        value={props.state.Expiration}
                        onChange={props.onChange} />
                    <Input
                        config={props.inputConfig}
                        disabled={props.loading || props.success}
                        name="CVC"
                        placeholder="CVC"
                        required
                        type="text"
                        value={props.state.CVC}
                        onChange={props.onChange} />
                </div>
            </div>
            <FormLabel display="Contact information" />
            <div className="input--double">
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="Email"
                    placeholder="Email Address"
                    required
                    type="email"
                    value={props.state.Email}
                    onChange={props.onChange} />
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="Phone"
                    placeholder="Phone"
                    required
                    type="text"
                    value={props.state.Phone}
                    onChange={props.onChange} />
            </div>
            <div className="input--double">
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="AddressLineOne"
                    placeholder="Address Line 1"
                    required
                    type="text"
                    value={props.state.AddressLineOne}
                    onChange={props.onChange} />
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="AddressLineTwo"
                    placeholder="Address Line 2"
                    type="text"
                    value={props.state.AddressLineTwo}
                    onChange={props.onChange} />
            </div>
            <div className="input--double">
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="City"
                    placeholder="City"
                    required
                    type="text"
                    value={props.state.City}
                    onChange={props.onChange} />
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="State"
                    placeholder="State"
                    required
                    type="text"
                    value={props.state.State}
                    onChange={props.onChange} />
            </div>
            <div className="input--double">
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="Zip"
                    placeholder="Zip Code"
                    type="text"
                    value={props.state.Zip}
                    onChange={props.onChange} />
                <Input
                    config={props.inputConfig}
                    disabled={props.loading || props.success}
                    name="Country"
                    placeholder="Country"
                    required
                    type="text"
                    value={props.state.Country}
                    onChange={props.onChange} />
            </div>
            <Input
                config={props.inputConfig}
                disabled={props.loading || props.success}
                name="Notes"
                placeholder="Notes/Requests"
                type="text"
                value={props.state.Notes}
                onChange={props.onChange} />
            <Arrows
                config={{ color: 'light' }}
                disabled={props.loading || props.success}
                display="Buy Now"
                form={true}
                type="submit" />
        </React.Fragment>
    );
}
const BuyNowForm = withSubmission(_BuyNowForm);

// region INQUIRE
function _InquireForm(props) {
    return (
        <React.Fragment>
            <Input
                config={{ size: 'small', style: 'outline', type: 'mc' }}
                disabled={props.loading || props.success}
                name="Name"
                placeholder="Full Name *"
                required
                type="text"
                value={props.state.Name}
                onChange={props.onChange} />
            <Input
                config={{ size: 'small', style: 'outline', type: 'mc' }}
                disabled={props.loading || props.success}
                name="Email"
                placeholder="Email Address *"
                required
                type="email"
                value={props.state.Email}
                onChange={props.onChange} />
            <Input
                config={{ size: 'small', style: 'outline', type: 'mc' }}
                disabled={props.loading || props.success}
                name="Phone"
                placeholder="Phone"
                type="text"
                value={props.state.Phone}
                onChange={props.onChange} />
            <Input
                config={{ size: 'small', style: 'outline', type: 'mc' }}
                disabled={props.loading || props.success}
                name="Message"
                placeholder="Enter your message here..."
                required
                textArea={true}
                type="text"
                value={props.state.Message}
                onChange={props.onChange} />
            <div id="example1" className="g-recaptcha" data-sitekey="6Ldz5BMUAAAAABRCXCk2a1Yxwhu7GLrbl7RDgKJZ"></div>
            <button
                className="btn btn--share"
                disabled={props.loading || props.success}
                type="submit">
                Submit
            </button>
            {
                props.loading &&
                <LoadingFull />
            }
        </React.Fragment>
    );
}
const InquireForm = withSubmission(_InquireForm);

// region OFFER
let _OfferModalInst;
class OfferModal extends React.Component {
    constructor(props) {
        super(props);

        let email, name;
        const user = Artcloud.auth.user;
        if (user) {
            email = user.Email;
            if (user.Name) {
                name = user.Name.Full;
            }
        }
        this.defaultPercent = 5;
        let localization;
        if (props.data.Gallery && props.data.Gallery.Localization) {
            localization = props.data.Gallery.Localization;
        }
        if (!localization) {
            localization = { CurrencySymbol: '$', DecimalPoint: '.', ThousandsSeparator: ',' };
        }
        const offerPrice = Math.ceil(props.data._Price * (1 - (this.defaultPercent / 100))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, localization.ThousandsSeparator);
        this.state = {
            Email: email,
            Name: name,
            Price: offerPrice,
            localization: localization
        };

        this.inputConfig = {
            color: 'light',
            size: 'medium',
            style: 'outline'
        };

        this._cleanValue = this._cleanValue.bind(this);
        this._formatCurrency = this._formatCurrency.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        _OfferModalInst = true;
    }

    componentWillUnmount() {
        _OfferModalInst = undefined;
    }

    _cleanValue(value) {
        return value.replace(/\D/g, '');
    }

    _formatCurrency(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, this.state.localization.ThousandsSeparator);
    }

    handleChange(name, value) {
        switch (name) {
            case 'Percent': {
                let price;
                const intValue = parseInt(value, 10);
                if (!isNaN(intValue)) {
                    price = (1 - (intValue / 100)) * this.props.data._Price;
                    price = this._formatCurrency(price + '');
                };
                return { Price: price };
            }
            case 'Price': {
                const cleanValue = this._cleanValue(value + '');
                const intValue = parseInt(cleanValue, 10);

                let percent;
                if (!isNaN(intValue)) {
                    const fullPrice = this.props.data._Price;
                    percent = Math.ceil((fullPrice - intValue) * 100 / fullPrice);
                }
                return { Percent: percent };
            }
        }
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSubmit(data, callback) {
        if (this.state.loading) {
            return;
        }
        const component = this;
        component.setState({
            loading: true
        });
        const postData = {
            ArtId: component.props.data.ArtId,
            Email: data.Email,
            GalleryId: component.props.data.Gallery && component.props.data.Gallery.GalleryId,
            Name: data.Name,
            Phone: data.Phone,
            Price: component._cleanValue(data.Price),
        };
        if (window && Cookies) {
            postData.Referrer = Cookies.get(Artcloud.auth.keys.cookies.referrer)
            postData.Utm = Cookies.get(Artcloud.auth.keys.cookies.utm)
        }
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.offers.post(),
            postData,
            function () {
                if (!_OfferModalInst) {
                    return;
                }
                component.setState({
                    loading: false
                });
                if (callback) {
                    callback(true, 'Your offer has been sent. Thank you!');
                }
            },
            function (jqXHR) {
                if (!_OfferModalInst) {
                    return;
                }
                component.setState({
                    loading: false
                });
                if (!callback) {
                    return;
                }
                callback(false, 'There was a problem sending your offer. Please wait a moment and try again.', jqXHR);
            }
        );
    }

    render() {
        const data = this.props.data || {};
        let image;
        if (data.Images && data.Images.length) {
            image = data.Images[0].MediumUrl;
        }
        let company;
        if (data.Gallery) {
            company = data.Gallery.Company;
        }
        return (
            <Popup className="form__container form--offer popup--offer" type="popup" onClose={this.handleClose}>
                <div className="popup--offer__inn">
                    <h5 className="form--offer__header">Make an offer</h5>

                    <div className="form__artwork">
                        <div className="form__artwork__img">
                            <img src={image} alt={data.Title} />
                        </div>
                        <div className="art__info">
                            {
                                data.Artist &&
                                <span className="art__user">{data.Artist.Name}</span>
                            }
                            <span className="art__title">{data.Title}</span>
                            <span className="art__details">
                                {
                                    data.Dimensions &&
                                    data.Dimensions.Display &&
                                    <span>{data.Dimensions.Display.Formatted}</span>
                                }
                                <span>{data.DisplayPrice}</span>
                                <span>{company}</span>
                            </span>
                        </div>
                    </div>

                    <p className="form__text">{company || 'The gallery'} is most likely to accept offers of 10% or less off the list price.</p>

                    <OfferForm
                        initialState={{
                            Email: this.state.Email,
                            Message: this.state.Message,
                            Name: this.state.Name,
                            Percent: this.defaultPercent,
                            Price: this.state.Price
                        }}
                        inputConfig={this.inputConfig}
                        loading={this.state.loading}
                        localization={this.state.localization}
                        onChange={this.handleChange}
                        onSubmit={this.handleSubmit} />
                    <div className="form__footer">
                        <p>You will receive an email confirmation</p>
                    </div>
                </div>
                {
                    this.state.loading &&
                    <LoadingFull style={{ backgroundColor: '#222' }} />
                }
            </Popup>
        );
    }
}

function _OfferForm(props) {
    return (
        <React.Fragment>
            <FormLabel display="Offer (fixed or percent off)" />
            <div className="input--double input--double--sep">
                <Input
                    config={{ color: 'light', size: 'medium', style: 'outline', type: 'currency' }}
                    disabled={props.loading || props.success}
                    name="Price"
                    placeholder="Offer Price"
                    required
                    type="text"
                    value={props.state.Price}
                    onChange={props.onChange}>
                    <span className="symbol">{props.localization.CurrencySymbol}</span>
                </Input>
                <Input
                    config={{ color: 'light', size: 'medium', style: 'outline', type: 'percent' }}
                    disabled={props.loading || props.success}
                    name="Percent"
                    pattern="[0-9]"
                    placeholder=""
                    required
                    type="number"
                    value={props.state.Percent}
                    onChange={props.onChange}>
                    <span className="unit">%</span>
                </Input>
            </div>
            <FormLabel display="Contact information" />
            <Input
                config={props.inputConfig}
                disabled={props.loading || props.success}
                name="Name"
                placeholder="Full Name *"
                required
                type="text"
                value={props.state.Name}
                onChange={props.onChange} />
            <Input
                config={props.inputConfig}
                disabled={props.loading || props.success}
                name="Email"
                placeholder="Email Address *"
                required
                type="email"
                value={props.state.Email}
                onChange={props.onChange} />
            <Input
                config={props.inputConfig}
                disabled={props.loading || props.success}
                name="Phone"
                placeholder="Phone *"
                required
                type="text"
                value={props.state.Phone}
                onChange={props.onChange} />
            <Arrows
                config={{ color: 'light' }}
                disabled={props.loading || props.success}
                display="Make an offer"
                form={true}
                type="submit" />
        </React.Fragment>
    );
}
const OfferForm = withSubmission(_OfferForm);

export default Art;